import { setSpecificMessage, isoWeek } from "valibot";
setSpecificMessage(
  isoWeek,
  (issue) => `Semaine invalide: reçu ${issue.received}`,
  "fr"
);